import { isEmpty } from 'ramda'

import { useUserAsParent } from 'app/dataProviders/user/hooks'

import { useAcquiringSettingsData } from './useAcquiringSettingsData'

export function useAcquiringSettingsAvailability() {
  const parentID = useUserAsParent()

  const { availableRefillTypes } = useAcquiringSettingsData()

  return !!parentID && !isEmpty(availableRefillTypes)
}
